import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import { Field } from 'formik';

import OutlinedSelectInput from '../Global/Inputs/OutlinedSelect';
import DateFieldInput from '../Global/Inputs/DateField';
import TextFieldInput from '../Global/Inputs/TextField';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import FormItemContainer from '../Global/Containers/FormItemContainer';
import { AppContext } from '../../AppProvider';

const styles = theme => ({
  shipmentMode: {
    marginTop: theme.spacing.unit * 0.75,
    marginBottom: theme.spacing.unit * 2
  }
});

export class BasicInfo extends Component {
  static propTypes = {
    handleValidateField: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired
  };
  render() {
    const {
      t,
      classes,
      values,
      handleChange,
      handleValidateField
    } = this.props;
    const {
      shipmentModes,
      shipmentDirections
    } = this.context.globalProps.referenceData;

    return (
      <FormItemContainer
        title={t('Basic Information')}
        classes={{ container: classes.container }}
      >
        <div className={classes.shipmentMode}>
          <Field
            name="shipmentModeId"
            onChange={handleChange}
            render={({ field, form }) => {
              return (
                <OutlinedSelectInput
                  value={values['shipmentModeId']}
                  field={field}
                  form={form}
                  label={t('Shipment Type')}
                  validateField={handleValidateField}
                  options={shipmentModes}
                />
              );
            }}
          />
        </div>
        <div className={classes.verticalGridItem}>
          <Field
            name="shipmentDirectionId"
            onChange={handleChange}
            render={({ field, form }) => {
              return (
                <OutlinedSelectInput
                  value={values['shipmentDirectionId']}
                  field={field}
                  form={form}
                  label={t('Shipment Direction')}
                  options={shipmentDirections}
                  validateField={handleValidateField}
                  multiple={false}
                />
              );
            }}
          />
        </div>
        <div className={classes.verticalGridItem}>
          <Field
            name={'pickup.plannedToTimeLocal'}
            onChange={handleChange}
            component={({ field, form }) => (
              <DateFieldInput
                value={values.pickup.plannedToTimeLocal}
                field={field}
                form={form}
                label={t('Planned Pickup Date')}
                format={'MMM DD, YYYY'}
                validateField={handleValidateField}
              />
            )}
          />
        </div>
        <div className={classes.verticalGridItem}>
          <Field
            value={values.totalLinearFeet}
            endAdornment={'ft'}
            name={'totalLinearFeet'}
            label={t('Linear Feet')}
            onChange={handleChange}
            component={TextFieldInput}
          />
        </div>
      </FormItemContainer>
    );
  }
}

BasicInfo.contextType = AppContext;
const BasicInfoWithTranslation = withNamespaces()(BasicInfo);
export default withStyles(
  combineStyles(LayoutStyles, TypographyStyles, SpacingStyles, styles)
)(BasicInfoWithTranslation);
